import {
  CHAT_NO_CONVERSATION_SELECTED,
  CHAT_WELCOME_TITLE,
} from '../../constants/ui';
import {
  selectConversations,
  selectCurrConversation,
} from '@/features/control/controlSlice';

import ChatHeader from './ChatHeader';
import ChatInputs from './ChatInputs';
import ChatMessages from './ChatMessages';
import { PenSquareIcon } from 'lucide-react';
import { useAppSelector } from '@/hooks/redux';
import { selectIsDetailsPaneOpen } from '@/features/details/detailsSlice';
import clsx from 'clsx';

const Chat = () => {
  const conversations = useAppSelector(selectConversations);
  const currConversationIndex = useAppSelector(selectCurrConversation);
  const isDetailsPaneOpen = useAppSelector(selectIsDetailsPaneOpen);

  return (
    // Below md the layout is single-pane: the chat shows only when a conversation
    // is open and the details pane isn't covering it; desktop (md+) always shows it.
    <section
      className={clsx(
        "flex-col h-full col-span-1 md:col-span-2 p-2 md:p-4 overflow-x-hidden overflow-y-auto",
        currConversationIndex !== null && !isDetailsPaneOpen ? "flex" : "hidden md:flex"
      )}
    >
      {currConversationIndex !== null ? (
        <>
          <ChatHeader />
          <ChatMessages />
          <ChatInputs />
        </>
      ) : (
        <div className="flex items-center justify-center h-full col-span-2">
          {conversations.length > 0 ? (
            <p className="text-neutral-400">{CHAT_NO_CONVERSATION_SELECTED}</p>
          ) : (
            <div className="flex flex-col gap-1 text-neutral-400">
              <p className="text-xl">{CHAT_WELCOME_TITLE}</p>
              <span className="flex items-center justify-center text-md">
                Press <PenSquareIcon className="inline w-5 mx-2" /> to create a
                conversation
              </span>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default Chat;
